import React from 'react';
import { Helmet } from 'react-helmet-async';

function SEO({ title, description, keywords, image, pathname }) {
  const siteUrl = "https://iofellowship.org"; // Your actual domain

  // Default values related to Intellectual Oasis Fellowship
  const defaultTitle = "Intellectual Oasis Fellowship | Research Education, Scholarships, and Academic Development";
  const defaultDescription = "Intellectual Oasis Fellowship (IOF) educational research organization, providing scholarships, student support, and educational funding to empower students in Nigeria and Africa. Join us in fostering academic excellence and creating a brighter future through education.";
  const defaultKeywords = "Intellectual Oasis Fellowship, IOF, research, scholarships, student support, educational funding, academic fellowship, student scholarships, education donations, Nigeria education, African scholarships";
  const defaultImage = `${siteUrl}/images/logo.jpg`; // Replace with your default image path

  const facebookPageUrl = "https://www.facebook.com/profile.php?id=61561270017439";
  const instagramProfileUrl = "https://www.instagram.com/io_fellowship/";
  const linkedinPageUrl = "https://www.linkedin.com/company/intellectual-oasis-fellowship";

  // Generate proper canonical URL
  const canonicalUrl = new URL(pathname || '/', siteUrl).toString();
  
  // Resolve image URL to absolute URL
  const resolvedImage = image 
    ? (image.startsWith('http') ? image : new URL(image, siteUrl).toString())
    : defaultImage;

  return (
    <Helmet>
      {/* Character set and viewport */}
      <meta charset="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      
      {/* Language */}
      <html lang="en" />
      
      {/* Basic meta tags */}
      <title>{title || defaultTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      
      {/* Theme color for browser */}
      <meta name="theme-color" content="#your-brand-color" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title || defaultTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:image" content={resolvedImage} />
      <meta property="og:site_name" content="Intellectual Oasis Fellowship" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={title || defaultTitle} />
      <meta property="twitter:description" content={description || defaultDescription} />
      <meta property="twitter:image" content={resolvedImage} />

      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
      <meta name="robots" content="index, follow" />

      {/* Social Media Profiles */}
      <meta property="og:see_also" content={facebookPageUrl} />
      <meta property="og:see_also" content={instagramProfileUrl} />
      <meta property="og:see_also" content={linkedinPageUrl} />
      
      {/* Social Profile Links */}
      <link rel="me" href={facebookPageUrl} />
      <link rel="me" href={instagramProfileUrl} />
      <link rel="me" href={linkedinPageUrl} />
    </Helmet>
  );
}

export default SEO;